<template>
    <div class="userControl spackage padding-20 bgc box-shadow">
        <div class="goods_search_warp flex_box">
            <div>
                <!-- :picker-options="disabledDatePickerOptions" -->
                <el-date-picker
                    v-model="searchParams.times"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm">
                </el-date-picker>
                <!-- <el-date-picker
                    v-model="searchParams.times"
                    value-format="yyyy-MM-dd HH-mm-ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间">
                </el-date-picker> -->
            </div>
            <div style="width: 157px;">
                <el-input v-model="searchParams.username" placeholder="请输入用户名称"></el-input>
            </div>
            <div style="width: 246px;">
                <el-input v-model="searchParams.communityname" placeholder="请输入社群名称"></el-input>
            </div>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </div>
        <div class="user_table_box">
            <el-table :data="goodsListData" style="width: 100%">
                <el-table-column label="用户名称" align='left' width="300">
                    <template slot-scope="scope">
                        <div class="user_row_box flex_box">
                            <img :src="scope.row.customericonurl" alt="">
                            <span>{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="社群名称" align='center' width="160">
                    <template slot-scope="scope">
                        <p class="community_name_text">{{scope.row.cname}}</p>
                    </template>
                </el-table-column> -->
                <el-table-column prop="assname" label="社群名称" align='center' width="160"></el-table-column>
                <el-table-column prop="invitecount" label="邀请人数" align='center'></el-table-column>
                <el-table-column prop="ordercount" label="成交订单数" align='center'></el-table-column>
                <el-table-column prop="ordermoney" label="成交订单金额" align='center'></el-table-column>
                <el-table-column prop="datetime" label="加入时间" align='center'></el-table-column>
                <el-table-column label="操作" align='center'>
                    <template slot-scope="scope">
                        <el-button type="text" @click="detailsBtn(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchBtn"></page>
        </div>
    </div>
</template>

<script>
import Page from 'base/page/page'
import {getUserInfoList} from 'api/cPurchaseApi'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'UserControl',
    data() {
        return {
            total: 0,
            searchParams: {
                username: '',
                communityname: '',
                times: ''
            },
            // disabledDatePickerOptions: {
            //     disabledDate(time) {
            //         // return time.getTime() > Date.now() - 24 * 60 * 60 * 1000
            //         return time.getTime() > Date.now() - 60 * 60 * 1000
            //     }
            // },
            goodsListData: []
        }
    },
    mounted() {
        this.getUserList()
    },
    methods: {
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        searchBtn() {
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            var params = {
                assname: this.searchParams.communityname,
                customername: this.searchParams.username,
                begintime: this.searchParams.times[0],
                endtime: this.searchParams.times[1]
            }
            this.setLoading(true)
            getUserInfoList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 社群用户列表
        getUserList() {
            this.setLoading(true)
            // var params = {
            //     eventinnerid: this.$route.query.eventinnerid
            // }
            getUserInfoList({
                // data: Object.assign({}, params, this.page),
                data: Object.assign({}, this.page),
                success: data => {
                    this.setLoading(false)
                    this.goodsListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 详情
        detailsBtn(val) {
            // this.$message.success(`详情按钮!!`)
            // console.log(val)
            this.$router.push({name: 'UserControlInfo', query: {assinnerid: val.assinnerid, innerid: val.innerid, customerinnerid: val.customerinnerid}})
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss">
    .userControl{
        .flex_box{
            display: flex;
        }
        .goods_search_warp{
            justify-content: flex-end;
            margin-bottom: 30px;
            // .el-input__inner {
            //     height: 36px;
            // }
            // .el-input__icon {
            //     line-height: 0;
            //     height: 36px;
            // }
            // .el-button {
            //     height: 36px;
            // }
            .el-input__icon {
                line-height: 2px;
            }
            &>div{
                margin-right: 30px;
                .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
                    width: 240px;
                }
                .el-date-editor .el-range-separator {
                    line-height: 26px;
                }
            }
        }
        .user_table_box{
            .el-table th>.cell {
                font-weight: bold!important;
                white-space: nowrap;
                font-size: 16px;
            }
            .el-table__empty-block {
                min-height: 500px;
            }
            .user_row_box{
                align-items: center;
                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 100%;
                    margin-right: 10px;
                }
            }
        }
    }

</style>